import React, { useEffect, useState } from "react";
import {
  Box,
  Typography,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Button,
  CircularProgress,
} from "@mui/material";
import axios from "../../../config/axiosConfig";
import Alert from "@mui/material/Alert";

// Estado 5 (Entregado) de una OT de Venta con activación: espejo simplificado de
// concluyendoad.php (sin el formulario de descuentos/observacion_factura, mismo
// criterio que ConcluirOT.jsx). El precio ya se fijó al Vender (VenderEquipoOT.jsx) —
// acá solo se muestra, no se vuelve a editar — y concluye: AVL/Scada salta directo a
// Finalizado (7); el resto queda en Concluido (6) y de ahí sigue el paso genérico de
// firma ya existente.
const headCellSx = {
  fontWeight: 800,
  bgcolor: (t) => (t.palette.mode === "dark" ? t.palette.background.paper : t.palette.grey[100]),
};
const tableSx = { "& .MuiTableCell-root": { py: 0.1, px: 0.6, fontSize: 10.5, lineHeight: 1.3 } };

const ConcluirVentaOT = ({ cod_ot, esTKR, onConcluido }) => {
  const [items, setItems] = useState([]);
  const [observacion, setObservacion] = useState("");
  const [loading, setLoading] = useState(true);
  const [guardando, setGuardando] = useState(false);
  const [error, setError] = useState("");

  useEffect(() => {
    setLoading(true);
    axios.get(`/api/ot-venta/activados/${cod_ot}`)
      .then((res) => setItems(res.data || []))
      .catch(() => setItems([]))
      .finally(() => setLoading(false));
  }, [cod_ot]);

  const concluir = async () => {
    if (!window.confirm("¿Concluir esta Venta con los precios indicados?")) return;
    setGuardando(true);
    setError("");
    try {
      const payload = {
        items: items.map((r) => ({
          familia: r.familia,
          identificador: r.identificador,
          precioVenta: Number(r.precio_venta) || 0,
        })),
        observacion,
      };
      const res = await axios.patch(`/api/ot-venta/finalizar-con-precio/${cod_ot}`, payload);
      if (onConcluido) onConcluido(res.data);
    } catch (err) {
      setError(err?.response?.data?.error || "No se pudo concluir la venta.");
    } finally {
      setGuardando(false);
    }
  };

  if (loading) {
    return <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}><CircularProgress size={20} /></Box>;
  }

  return (
    <Box sx={{ mt: 1 }}>
      {error && <Alert severity="error" sx={{ mb: 1.5 }}>{error}</Alert>}

      <Typography variant="subtitle2" sx={{ fontWeight: 800, mb: 0.5 }}>
        {esTKR ? "Radios y baterías vendidos" : "Módems y chips vendidos"}
      </Typography>
      <TableContainer component={Paper} variant="outlined" sx={{ mb: 2, maxHeight: 320, borderRadius: 0.5 }}>
        <Table size="small" stickyHeader sx={tableSx}>
          <TableHead>
            <TableRow>
              <TableCell sx={headCellSx}>Identificador</TableCell>
              <TableCell sx={headCellSx}>Modelo</TableCell>
              <TableCell sx={{ ...headCellSx, width: 110 }} align="right">Precio</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {!items.length ? (
              <TableRow>
                <TableCell colSpan={3}>
                  <Typography variant="body2" color="text.secondary" sx={{ fontStyle: "italic" }}>
                    No hay equipos activados en esta OT.
                  </Typography>
                </TableCell>
              </TableRow>
            ) : (
              items.map((r) => {
                const key = `${r.familia}-${r.identificador}`;
                return (
                  <TableRow key={key} hover>
                    <TableCell>{r.identificador}</TableCell>
                    <TableCell>{r.modelo}</TableCell>
                    <TableCell align="right">{Number(r.precio_venta || 0).toFixed(2)}</TableCell>
                  </TableRow>
                );
              })
            )}
          </TableBody>
        </Table>
      </TableContainer>

      <TextField
        label="Observación de Conclusión"
        fullWidth
        multiline
        rows={3}
        value={observacion}
        onChange={(e) => setObservacion(e.target.value)}
        sx={{ mb: 2 }}
      />

      <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
        <Button variant="contained" color="success" onClick={concluir} disabled={guardando}>
          {guardando ? <CircularProgress size={20} color="inherit" /> : "Concluir Venta"}
        </Button>
      </Box>
    </Box>
  );
};

export default ConcluirVentaOT;
